
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import draggable from 'vuedraggable'
	import shoplist from '@/components/shoplist.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      draggable,
      shoplist
    }
  })

  export default class ProductList extends Vue {
    private show = false
    private shopList:any = []
    private index = -1
    @Inject() information:any
    get value(){
      return this.information
    }
    
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    private getshop(e){
      if(!e||!e.length){
        this.$message.error('请选择商品')
        return 
      }
      this.show = false
      this.editmsg.list[this.index].shopList = e.sort((a,b)=>{
        return b.Sort-a.Sort
      })
    }
    private pushShop(i){
      this.index = i
      this.shopList = this.editmsg.list[i].shopList
      this.show = true
    }
    private removeShop(i,y){
      this.editmsg.list[i].shopList.splice(y,1)
    }
    private del(e){
      this.editmsg.list.splice(e,1)
    }
    private add(){
      if(this.editmsg.list.length>=20){
        this.$message.error('最多添加20组分类')
        return 
      }
      this.editmsg.list.push({
        name:'',
        shopList:[]
      })
    }
  }
